import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { useContext } from 'react';
import { ErrorContext, actions } from '../../contexts/error/context';
import { prettifyAppName } from '../../utils/general';
import ApiOutagePlaceholder from './ApiOutagePlaceholder/ApiOutagePlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorModal({
  message,
  ctaFunction
}) {
  const {
    isExternalOutage,
    appName
  } = useContext(ErrorContext);
  const onClickFix = () => {
    if (ctaFunction) {
      ctaFunction();
    }
    actions.resetError();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    "data-test-id": `${appName}-full-screen-error-modal`,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "errors.modal.title"
          })
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: isExternalOutage ? /*#__PURE__*/_jsx(ApiOutagePlaceholder, {
        title: I18n.text('errors.externalOutage.title', {
          appName: prettifyAppName(appName)
        }),
        description: I18n.text('errors.externalOutage.description', {
          appName: prettifyAppName(appName)
        })
      }) : /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest",
        "data-test-id": `${appName}-full-screen-error-modal-message`,
        illustrationProps: {
          marginBlockEnd: '800',
          inlineSize: '175px'
        },
        children: message
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onClickFix,
        "data-test-id": `${appName}-full-screen-error-modal-button`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "errors.modal.button"
        })
      })
    })]
  });
}
export default ErrorModal;